"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CreateMeetingError", {
  enumerable: true,
  get: function get() {
    return _CreateMeetingError["default"];
  }
});
var _CreateMeetingError = _interopRequireDefault(require("./CreateMeetingError"));